<template>
  <span>
    <!-- NOTE: (Florent)
    We have to use click.native
    c.f. https://github.com/vuejs/vue-router/issues/800
    -->
    <router-link v-on:click.native="trackTagClicked({
        tag: tag,
        source: 'resource'
      })"
      :to="{ name: 'single-topic', params: { name: tag } }"
    >#{{ tag | asTag }}</router-link>
  </span>
</template>

<script>
import { trackTagClicked } from '@/utils/analytics/main'

export default {
  name: 'TopicLabel',
  props: {
    tag: {
      type: String,
      required: true
    }
  },
  methods: {
    trackTagClicked
  }
}
</script>
